export const formatSwedishCurrency = (
  number: number,
  suffix?: string
): string => `${number?.toLocaleString('sv-SE')}${suffix ? ` ${suffix}` : ''}`;
